/**
 * JSON utility module for symbol
 */
define("tmds/utils/symbolUtils", [
	"jquery",
	"tmds/symbols/CompositePointSymbol",
	"tmds/utils/__baseSymbolUtils",
	"tmds/validator"
], function($, CompositePointSymbol, baseSymbolUtils, validator) {
	"use strict";
	
	/**
	 * create symbol object from a JSON representation
	 * @param symJson {tmds.symbols.Symbol} a symbol in JSON representation
	 * @return {tmds.symbols.Symbol}
	 */
	function fromJson(symJson) {
		var symbol = null;
		
		if (! validator.isDataObject(symJson) || ! validator.isString(symJson.type)) {
			
			throw new Error('Invalid Symbol Object - ' + symJson + ' passed');
		}

		if (symJson) {
			switch (symJson.type) {
				case "FieldSymbol":
				case "SimplePointSymbol":
				case "SimpleLineSymbol":
				case "SimpleFillSymbol":
				case "TextSymbol":
					symbol = baseSymbolUtils.fromJson(symJson);
					break;
				case "CompositePointSymbol":
					symbol = new CompositePointSymbol(symJson);
					break;
				default:
					break;
			}
		}
		
		if(symbol == null)
			throw new Error('Invalid Symbol Object - ' + symJson + ' passed');
		
		return symbol;
	}
	
	var symbolUtils = {
		'fromJson' : fromJson,
		'fromSpatialType' : baseSymbolUtils.fromSpatialType
	};
	
	return symbolUtils;
});